import { useLoadingProtectUrl } from '@smx-ui-common/use-loading-protect-url';
import { Flex, Spin } from 'antd';
import * as React from 'react';

import { ViewerWrapperModalAppryze } from './viewer-wrapper-modal-appryze';

type ViewerProtectPictWrapperAppryzeProps = {
    urlPdf: string;
    urlPictPreview: string;
    token?: string;
    minHeight?: number;
    onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    title?: string;
};

export const ViewerProtectPictWrapperAppryze: React.FC<ViewerProtectPictWrapperAppryzeProps> = ({
    token = '',
    urlPdf,
    urlPictPreview,
    minHeight,
    onClick,
    title,
}) => {
    const { data: dataPdf, isInFlight: isInFlight1 } = useLoadingProtectUrl(urlPdf, token);
    const { data: dataPictPreview, isInFlight: isInFlight2 } = useLoadingProtectUrl(urlPictPreview, token);

    return (
        <Spin
            spinning={isInFlight1 || isInFlight2}
            style={{
                minHeight,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
            }}
        >
            <Flex
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {dataPdf && (
                    <ViewerWrapperModalAppryze
                        file={dataPdf || null}
                        mode={'pict'}
                        urlPictPreview={dataPictPreview}
                        onClick={onClick}
                        title={title}
                    />
                )}
            </Flex>
        </Spin>
    );
};
